<template>
  <b-modal size="md" centered :visible="showModal" @hidden="hide"
    ><template slot="modal-title">Wybierz warstwę docelową</template>

    <b-col md="12">
      <label for="chosenLayer" class="col-form-label">
        {{ description }}
      </label>
    </b-col>
    <b-col md="8">
      <b-select id="chosenLayer" v-model="selectedLayer">
        <option :title="'Wybierz'" :value="null" disabled>Wybierz</option>

        <option
          v-for="option in layersOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </b-select>
    </b-col>

    <div slot="modal-footer">
      <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
      <b-btn variant="primary" @click="confirmCopying">Tak</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CopyFeaturesModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedFeaturesCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedLayer: null
    };
  },
  watch: {
    showModal(newValue) {
      if (!newValue) {
        this.resetState();
      }
    }
  },
  computed: {
    ...mapGetters(['activeLayer', 'systemLayers', 'layersGeometryColumns']),
    description() {
      if (this.selectedFeaturesCount >= 2) {
        return `Wybierz warstwę do której mają zostać skopiowane ${this.selectedFeaturesCount} obiekty`;
      }

      return 'Wybierz warstwę do której ma zostać skopiowany obiekt';
    },
    layersOptions() {
      return this.systemLayers
        .sort((a, b) => {
          return b.order - a.order;
        })
        .filter(layer => {
          if (layer.id === this.activeLayer.id) return false;
          if (layer.type !== this.activeLayer.type) return false;

          const meta = this.layersGeometryColumns[layer.id];
          return meta && meta.column;
        })
        .map(layer => ({ label: layer.title, value: layer.id }));
    }
  },
  methods: {
    confirmCopying() {
      this.$emit('copy-selected-features', this.selectedLayer);
    },
    resetState() {
      this.selectedLayer = null;
    },
    hide() {
      this.$emit('hide');
    }
  }
};
</script>
